import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Layout from "../layout";

const PrivateRoute = ({ element: Component, redirectTo, ...rest }) => {
  const { currentUser, isAdmin } = useAuth();

  if (!currentUser) {
    return <Navigate to={redirectTo} />;
  }

  if (!isAdmin()) {
    return <Navigate to="/signin" />;
  }

  return (
    <Layout>
      <Component {...rest} />
    </Layout>
  );
};

export default PrivateRoute;
